import React from "react";
import { useTutorialsContext } from "../../TutorialsContext";

const Consent = () => {
    const { setDisabled } = useTutorialsContext();

    // Always enable the Proceed button
    React.useEffect(() => {
        setDisabled(false);
    }, [setDisabled]);

    return (
        <div style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            paddingTop: '120px', // increased padding to push everything down
            paddingBottom: '60px'
        }}>
              

            <div style={{
                border: '1px solid #E5E7EB',
                borderRadius: 12,
                overflow: 'hidden',
                marginBottom: 60,
                background: '#fff',
                boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
                maxWidth: 650,
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
            }}>
                <iframe
                    src="/consent-form.pdf"
                    title="Consent Form"
                    height="400px"
                    style={{
                        border: 'none',
                        width: '100%',
                        minWidth: 350,
                        display: 'block'
                    }}
                />
            </div>

            <div
                className="text"
                style={{
                    textAlign: "center",
                    marginBottom: 12,
                    fontSize: 20,
                    maxWidth: 900,
                    padding: '0 10px',
                }}
            >

                <strong>
                Please read the consent form. Clicking “Proceed” indicates your informed consent.
                </strong>
              
            </div>

            
        </div>
    );
};

export default React.memo(Consent);
